import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import EventForm, {
	EventFormValues
} from "../../components/EventForm/EventForm";
import useCreateEvent from "../../hooks/useCreateEvent";
import { adaptCreateEventPayload } from "../../adapters/adaptEventPayload";
import { formValuesToEvent } from "../../adapters/formValuesToEvent";

const EMPTY_DEFAULTS: EventFormValues = {
	name: "",
	location: "",
	body: "",
	startDate: "",
	startTime: "09:00",
	showStartDate: true,
	endDate: "",
	endTime: "18:00",
	showEndDate: true,
	tag: null,
	image: null,
	audienceGroupIds: []
};

const CreateEvent = () => {
	const navigate = useNavigate();
	const { mutate: createEvent, isLoading } = useCreateEvent();

	const handleSubmit = (data: EventFormValues) => {
		const payload = adaptCreateEventPayload(
			formValuesToEvent(data),
			data.image,
			data.audienceGroupIds
		);

		createEvent(payload, {
			onSuccess: () => navigate("/app/events")
		});
	};

	return (
		<Page>
			<EventForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
			/>
		</Page>
	);
};

export default CreateEvent;
